import { IWalletDetails } from "@market/interfaces/IWallet";
import { IUseWithdrawForm, IWithdrawFees } from "./IWithdrawForm";
import {
  withdrawAmountValidation,
  walletFormValidation,
  bankFormValidation,
} from "@funds/features/helpers/validation";

export const withdrawFormValidation = (
  values: IUseWithdrawForm["values"],
  userWallet: IWalletDetails,
  step: number,
  fees: IWithdrawFees[] | undefined,
  exchangeRate?: number,
  bicExternalValidationEnabled: boolean = false
) => {
  let errors: IUseWithdrawForm["errors"] = {};
  const amountError = withdrawAmountValidation(
    values,
    userWallet,
    fees,
    exchangeRate
  );

  switch (step) {
    case 1:
      // Amount validation
      if (amountError) errors.amount = amountError;

      // Wallet field validation
      if (!values.selectedWallet) errors.selectedWallet = "Required field.";
      break;

    case 4:
      // Bank Form validation
      errors = bankFormValidation(values, bicExternalValidationEnabled);
      // Amount validation
      if (amountError) errors.amount = amountError;
      break;

    case 5:
      // Wallet Form validation
      errors = walletFormValidation(values, userWallet.currency);

      // Amount validation
      if (amountError) errors.amount = amountError;
      break;
  }

  return errors;
};
